import React from "react";

export default function About() {
  return (
    <section id="chisiamo" className="cm-reveal py-20 lg:py-28">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.95fr_1.2fr] lg:gap-20">
          <div>
            <p className="label-mono mb-6">05 — Chi siamo</p>
            <h2 className="h-display text-[clamp(2rem,4vw,3.3rem)]">
              Un riferimento per comprare e vendere con informazioni chiare.
            </h2>
          </div>
          <div className="space-y-5 lg:pt-4">
            <p className="text-[1.05rem] leading-relaxed text-[#4a4a45]">
              Carmaps è a Collegno, in Corso Francia 115. Prima di proporre
              un'auto la controlliamo voce per voce e documentiamo nella scheda
              anche i difetti riscontrati: così sai davvero cosa stai valutando,
              senza sorprese.
            </p>
            <p className="text-[1.05rem] leading-relaxed text-[#4a4a45]">
              Chi vende non resta solo: ci occupiamo di valutazione,
              presentazione, annunci e gestione dei contatti fino alla consegna.
              Ogni auto ha una scheda pubblica con foto reali e, quando
              disponibile, il video.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
